import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["src", "alt", "fallback", "fallbackDelay", "id", "ariaLabel", "ariaLabelledby", "ariaDescribedby", "ariaDescription", "dataTestId", "xstyle"];
import { c as _c } from "react-compiler-runtime";
import { forwardRef } from 'react';
import { AvatarRoot, AvatarFallback, AvatarImage } from './primitives';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Config-layer wrapper for `Avatar`. Accepts flat `src`, `alt`, and `fallback`
 * props instead of composing `AvatarImage` and `AvatarFallback` by hand.
 *
 * This component is part of Trellis's config API layer and covers the majority
 * of use cases. For advanced patterns, use the compositive API directly. If you
 * find yourself doing so, share your use case in #trellis-support — it directly
 * informs how we evolve the config layer.
 *
 * @see {@link AvatarRoot | Avatar}
 */
export const Avatar = /*#__PURE__*/forwardRef((t0, ref) => {
  var _id, _ariaLabel, _ariaLabelledby, _ariaDescribedby, _ariaDescription, _dataTestId;
  const $ = _c(29);
  let alt;
  let ariaDescribedby;
  let ariaDescription;
  let ariaLabel;
  let ariaLabelledby;
  let dataTestId;
  let fallback;
  let fallbackDelay;
  let id;
  let restProps;
  let src;
  if ($[0] !== t0) {
    const {
        src: t1,
        alt: t2,
        fallback: t3,
        fallbackDelay: t4,
        id: t5,
        ariaLabel: t6,
        ariaLabelledby: t7,
        ariaDescribedby: t8,
        ariaDescription: t9,
        dataTestId: t10
      } = t0,
      t11 = _objectWithoutPropertiesLoose(t0, _excluded);
    src = t1;
    alt = t2;
    fallback = t3;
    fallbackDelay = t4;
    id = t5;
    ariaLabel = t6;
    ariaLabelledby = t7;
    ariaDescribedby = t8;
    ariaDescription = t9;
    dataTestId = t10;
    restProps = t11;
    $[0] = t0;
    $[1] = alt;
    $[2] = ariaDescribedby;
    $[3] = ariaDescription;
    $[4] = ariaLabel;
    $[5] = ariaLabelledby;
    $[6] = dataTestId;
    $[7] = fallback;
    $[8] = fallbackDelay;
    $[9] = id;
    $[10] = restProps;
    $[11] = src;
  } else {
    alt = $[1];
    ariaDescribedby = $[2];
    ariaDescription = $[3];
    ariaLabel = $[4];
    ariaLabelledby = $[5];
    dataTestId = $[6];
    fallback = $[7];
    fallbackDelay = $[8];
    id = $[9];
    restProps = $[10];
    src = $[11];
  }
  const t1 = (_id = id) === null || _id === void 0 ? void 0 : _id.root;
  const t2 = (_ariaLabel = ariaLabel) === null || _ariaLabel === void 0 ? void 0 : _ariaLabel.root;
  const t3 = (_ariaLabelledby = ariaLabelledby) === null || _ariaLabelledby === void 0 ? void 0 : _ariaLabelledby.root;
  const t4 = (_ariaDescribedby = ariaDescribedby) === null || _ariaDescribedby === void 0 ? void 0 : _ariaDescribedby.root;
  const t5 = (_ariaDescription = ariaDescription) === null || _ariaDescription === void 0 ? void 0 : _ariaDescription.root;
  const t6 = (_dataTestId = dataTestId) === null || _dataTestId === void 0 ? void 0 : _dataTestId.root;
  let t7;
  if ($[12] !== alt || $[13] !== src) {
    var _alt;
    t7 = src != null && /*#__PURE__*/_jsx(AvatarImage, {
      src: src,
      alt: (_alt = alt) !== null && _alt !== void 0 ? _alt : ""
    });
    $[12] = alt;
    $[13] = src;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== fallback || $[16] !== fallbackDelay) {
    t8 = fallback != null && /*#__PURE__*/_jsx(AvatarFallback, {
      delay: fallbackDelay,
      children: fallback
    });
    $[15] = fallback;
    $[16] = fallbackDelay;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== ref || $[19] !== restProps || $[20] !== t1 || $[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t9 = /*#__PURE__*/_jsxs(AvatarRoot, Object.assign({}, restProps, {
      ref: ref,
      id: t1,
      "aria-label": t2,
      "aria-labelledby": t3,
      "aria-describedby": t4,
      "aria-description": t5,
      "data-test-id": t6,
      children: [t7, t8]
    }));
    $[18] = ref;
    $[19] = restProps;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
});
Avatar.displayName = 'Avatar';